<mat-chip>
    <div class="lock-container">
        <fa-icon icon="info-circle"></fa-icon>
        <span>Current Application Time Locked at: {{ lockedTime$ | async | momentDate : undefined : true }}</span>
    </div>
</mat-chip>
